import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { persons } from 'models/persons'; // Importing persons model

/**
 * AgeView class extends JetView to create a chart view for age-related data.
 */
export default class AgeView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for text
        return {
            type: 'clean', // Clean layout type
            rows: [
                {
                    template: _('Income from various age groups'), // Header template with localized text
                    type: 'header', // Header type
                    css: 'webix_header chart_header', // CSS class for styling
                },
                {
                    view: 'chart', // Chart component
                    type: 'scatter', // Scatter chart type
                    localId: 'chart', // Local ID for referencing the chart
                    padding: {
                        // Padding for the chart
                        top: 10,
                        left: 50,
                        bottom: 40,
                    },
                    xValue: (obj) => {
                        // Function to calculate x-axis value (age)
                        return (
                            new Date().getFullYear() - // Current year
                            new Date(obj.birthday).getFullYear() // Year of birth
                        );
                    },
                    value: '#money#', // Data field for y-axis value
                    item: {
                        // Item configuration for chart points
                        borderColor: '#fff', // Border color of points
                        color: '#8664C6', // Fill color of points
                        shadow: false, // Shadow effect
                        radius: 7, // Radius of points
                        type: 'd', // Point type
                    },
                    xAxis: {
                        // Configuration for x-axis
                        start: 22, // Starting value
                        end: 44, // Ending value
                        step: 4, // Step size
                        lines: false, // Disable grid lines
                        color: '#EDEFF0', // Axis color
                    },
                    yAxis: {
                        // Configuration for y-axis
                        start: 0, // Starting value
                        end: 1500, // Ending value
                        step: 500, // Step size
                        color: '#fff', // Axis color
                        lineColor: '#EDEFF0', // Line color
                    },
                    tooltip: {
                        // Tooltip configuration
                        template: '<b>#fname# #lname#</b><br>$#money#', // Tooltip template
                    },
                },
            ],
        };
    }

    /**
     * Initializes the view and synchronizes the chart with the persons model.
     */
    init() {
        this.$$('chart').sync(persons); // Sync chart data with persons model
    }
}

// FILE DOCUMENTED
